<template>
	<div class="recipe-slide">
		<router-link draggable="false" :to="'/recipes/' + recipe.slug" class="image-link">
			<lazy-background :src="recipe.image_source.thumb640 "></lazy-background>
		</router-link>
		<h3><router-link draggable="false" :to="'/recipes/' + recipe.slug">{{ recipe.name }}</router-link></h3>
		<div class="tags" v-if="recipe.tags.length > 0">
			<router-link draggable="false" v-for="(tag, i) in recipe.tags" :key="recipe.slug + '-' + tag.id" :to="'/recipes/tag/' + tag.slug">{{ tag.name }}</router-link>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['value'],
		data() {
			return {
				recipe: this.value
			};
		},
		watch: {
			value() {
				this.recipe = this.value;
			},
			recipe() {
				this.$emit('input', this.recipe);
			}
		}
	}
</script>